import {ReactNode} from 'react';

interface PageTitleProps {
  children: ReactNode;
  extra?: ReactNode;
}

export const PageTitle = ({children, extra}: PageTitleProps) => (
  <div className="flex items-center">
    <h2 className="flex h-10 items-center gap-2 text-title-h1">{children}</h2>
    {extra && <div className="ml-auto flex gap-4">{extra}</div>}
  </div>
);
